document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.m-menu-mobile__item').forEach(function (item) {
    const link = item.querySelector('.m-menu-mobile__link');
    const toggleButton = item.querySelector('.m-menu-mobile__toggle-button');

    if (!link || !toggleButton) return;

    link.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      // Simule un clic sur la flèche
      toggleButton.click();
    });
  });
});
